/**
 * Build-time environment values.
 *
 * These read uniquely-named globals injected by Vite `define` (see
 * vite.config.ts). We use dedicated globals rather than reading
 * `import.meta.env.*` directly because Vite's internal handling of
 * `import.meta.env` can override a user `define`, which left the values
 * undefined at tree-shake time on Cloudflare. The `import.meta.env` fallback
 * keeps `pnpm dev` working, where these globals are not defined.
 */
declare const __BW_SUPABASE_URL__: string | undefined;
declare const __BW_SUPABASE_PUBLISHABLE_KEY__: string | undefined;
declare const __BW_RUNTIME_URL__: string | undefined;

export const BW_SUPABASE_URL: string =
  (typeof __BW_SUPABASE_URL__ !== 'undefined' ? __BW_SUPABASE_URL__ : '') ||
  import.meta.env.VITE_SUPABASE_URL ||
  '';

export const BW_SUPABASE_PUBLISHABLE_KEY: string =
  (typeof __BW_SUPABASE_PUBLISHABLE_KEY__ !== 'undefined' ? __BW_SUPABASE_PUBLISHABLE_KEY__ : '') ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  '';

export const BW_RUNTIME_URL: string =
  (typeof __BW_RUNTIME_URL__ !== 'undefined' ? __BW_RUNTIME_URL__ : '') ||
  import.meta.env.VITE_RUNTIME_URL ||
  'http://localhost:5174/';
